export const market = {
    Forex: [
        {
            name: 'AUDNZD',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'AUDCAD',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'AUDCHF',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'AUDJPY',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'CHFJPY',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'EURGBP',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'EURAUD',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'EURCHF',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'EURJPY',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'EURNZD',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'EURCAD',
            price: '1.1028',
            Change: '0'
        },

        {
            name: 'GBPCHF',
            price: '1.1028',
            Change: '0'
        },
    ],
    Commodities: [
        {
            name: 'LCCN4',
            label: 'AAL',
            price: '12.98',
            Change: '0',
            icon: "/Images/com1.png",
        },

        {
            name: 'CCU4',
            price: '239.33',
            Change: '0',
            icon: "/Images/com2.png",
            label: 'AAPL',
        },

        {
            name: 'KC0724',
            price: '199.56',
            Change: '0',
            icon: "/Images/com3.png",
            label: 'AMZN',
        },

      


        {
            name: 'CTZ4',
            price: '173.9',
            Change: '0',
            icon: "/Images/com5.png",
            label: 'GOOGL',
        },

    

        {
            name: 'ZS0724',
            price: '394.13',
            Change: '0',
            icon: "/Images/com10.png",
            label: 'MSFT',
        },
         {
            name: 'LCCN4',
            label: 'AAL',
            price: '12.98',
            Change: '0',
            icon: "/Images/com1.png",
        },

        {
            name: 'CCU4',
            price: '239.33',
            Change: '0',
            icon: "/Images/com2.png",
            label: 'AAPL',
        },

        {
            name: 'KC0724',
            price: '199.56',
            Change: '0',
            icon: "/Images/com3.png",
            label: 'AMZN',
        },

      


        {
            name: 'CTZ4',
            price: '173.9',
            Change: '0',
            icon: "/Images/com5.png",
            label: 'GOOGL',
        },

    

        {
            name: 'ZS0724',
            price: '394.13',
            Change: '0',
            icon: "/Images/com10.png",
            label: 'MSFT',
        },



    ],
    Metals: [
        {
            name: 'XAUAUD',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal1.png",
        },

        {
            name: 'XAUEUR',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal2.png",
        },

        {
            name: 'XAUGBP_',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal3.png",
        },

        {
            name: 'XAUUSD_',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal4.png",
        },

        {
            name: 'XAGEUR_',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal5.png",
        },

        {
            name: 'XAGUSD_',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal6.png",
        },

        {
            name: 'XAUAUD',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal1.png",
        },

        {
            name: 'XAUEUR',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal2.png",

        },

        {
            name: 'XAUGBP',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal3.png",
        },

        {
            name: 'XAUUSD',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal4.png",
        },

        {
            name: 'XAGEUR',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal5.png",
        },

        {
            name: 'XAGUSD',
            price: '1.1028',
            Change: '0',
            icon: "/Images/metal6.png",
        },
    ],
    Energies: [
        {
            name: 'BRENT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/ener1.png",
        },

        {
            name: 'WTI',
            price: '1.1028',
            Change: '0',
            icon: "/Images/ener2.png",
        },

        {
            name: 'NatGas',
            price: '1.1028',
            Change: '0',
            icon: "/Images/ener3.png",
        },
        {
            name: 'BRENT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/ener1.png",
        },

        {
            name: 'WTI',
            price: '1.1028',
            Change: '0',
            icon: "/Images/ener2.png",
        },

        {
            name: 'NatGas',
            price: '1.1028',
            Change: '0',
            icon: "/Images/ener3.png",
        },
    ],
    Indices: [
        {
            name: 'CAC40_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi1.png",

        },

        {
            name: 'CH20_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi2.png",
        },

        {
            name: 'EUR50_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi3.png",
        },

        {
            name: 'GER30_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi4.png",
        },

        {
            name: 'IBEX35_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi5.png",
        },

        {
            name: 'IT40_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi6.png",
        },

        {
            name: 'NL25_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi7.png",
        },

        {
            name: 'NO25_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi8.png",
        },

        {
            name: 'UK100_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi9.png",
        },

        {
            name: 'AUS200_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi10.png",
        },

        {
            name: 'CA60_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi11.png",
        },

        {
            name: 'HKD50_SPOT',
            price: '1.1028',
            Change: '0',
            icon: "/Images/indi12.png",
        },
    ],
    Crypto: [
        {
            name: 'DOGE Coin',
            price: '24.07',
            Change: '0',
            icon: "/Images/ddddddd.png",

        },

        {
            name: 'AVAX',
            price: '28.75',
            Change: '0',
            icon: "/Images/aaaaa.png",
        },

        {
            name: 'Bitcoin',
            price: '76.12',
            Change: '0',
            icon: "/Images/BITS.png",
        },

        {
            name: 'Polka Dot',
            price: '30.03',
            Change: '0',
            icon: "/Images/POLAKA.png",
            // icon: "/Images/USDC.png",    
        },

        {
            name: "Solana",
            price: '15.98',
            Change: '0',
            icon: "/Images/solanaa.png",
        },

        {
            name: 'Ripple',
            price: '33.3',
            Change: '0',
            icon: "/Images/rrrrr.png",
        },

        {
            name: 'Bitcoin',
            price: '33.39',
            Change: '0',
            icon: "/Images/bbbbb.png",
        },
        {
            name: 'Ethereum',
            price: '33.39',
            Change: '0',
            icon: "/Images/eeeee.png",
        },
        {
            name: 'Shiba Inu',
            price: '33.39',
            Change: '0',
            icon: "/Images/ssss.png",
        },
        {
            name: 'USDT',
            price: '33.39',
            Change: '0',
            icon: "/Images/TRO.png",
        },

       
    ],

    Stocks: [
        {
            name: 'AAPL.OQ',
            price: '7702',
            Change: '0',
            icon: "/Images/four1.png",
        },

        {
            name: 'AMZN.OQ',
            price: '9095',
            Change: '0',
            icon: "/Images/four7.png",
        },

        {
            name: 'GOOGL.OQ',
            price: '225.82',
            Change: '0',
            icon: "/Images/four2.png",
        },

        {
            name: 'IBM.N',
            price: '4.3657',
            Change: '0',
            icon: "/Images/four3.png",
        },

        {
            name: 'INTC.OQ',
            price: '69.7',
            Change: '0',
            icon: "/Images/Group (4).png",
        },

        {
            name: 'META.OQ',
            price: '2.696',
            Change: '0',
            icon: "/Images/four4.png",
        },

        {
            name: 'MSFT.OQ',
            price: '2.076',
            Change: '0',
            icon: "/Images/four5.png",
        },

        {
            name: 'NFLX.OQ',
            price: '81.548',
            Change: '0',
            icon: "/Images/slider1.png",
        },

        {
            name: 'NVDA.OQ',
            price: '85.948',
            Change: '0',
            icon: "/Images/greeeen.png",
        },

        {
            name: 'PYPL.OQ',
            price: '988',
            Change: '0',
            icon: "/Images/PYPL.png",
        },

        {
            name: 'TSLA.OQ',
            price: '1158.1',
            Change: '0',
            icon: "/Images/four10.png",
        },
    ],
}



